/* @flow */

import {
    ETAPA_ENTREGA,
    ETAPA_APROVADO,
    ETAPA_PENDENTE,
    ETAPA_EXECUCAO,
    ETAPA_FINALIZADO,
    ETAPA_CANCELADO,
    ETAPA_DEVOLVIDO,
} from '../pedidos/constants';
import { type EtapasId } from '../pedidos/types';
import { type StateColors } from '../utils/types';

export const COR_ETAPA: { [EtapasId]: StateColors } = {
    [ETAPA_PENDENTE]: 'brand',
    [ETAPA_EXECUCAO]: 'primary',
    [ETAPA_ENTREGA]: 'info',
    [ETAPA_FINALIZADO]: 'success',
    [ETAPA_CANCELADO]: 'danger',
    [ETAPA_DEVOLVIDO]: 'warning',
    [ETAPA_APROVADO]: 'metal',
};

export const TAMANHO_ETAPA = {
    [ETAPA_PENDENTE]: '0%',
    [ETAPA_EXECUCAO]: '33%',
    [ETAPA_ENTREGA]: '67%',
    [ETAPA_FINALIZADO]: '100%',
    [ETAPA_DEVOLVIDO]: '100%',
    [ETAPA_CANCELADO]: '100%',
};

export const CLASSE_BOTAO_ETAPA = 'botao-etapa';
export const ID_WIZARD_ETAPA = 'wizard-etapa';
export const ID_WIDGET_ENDERECO = 'endereco-etapa';
export const CLASSE_ETAPA_SELECIONADO = 'm-wizard__step--current';
export const NOME_SEM_CLIENTE = 'Sem cliente';
export const SEM_ENDERECO = 'Sem endereço';
